import { render, staticRenderFns } from "./UpgradePlanPopup.vue?vue&type=template&id=fbb2a2d6"
import script from "./UpgradePlanPopup.vue?vue&type=script&lang=js"
export * from "./UpgradePlanPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports